import { ACTION_IDS }       from '../../constants/catalogDataDisplay.js';

import { FavoritesAction }   from './FavoritesAction.jsx';
import { FloorPlanAction }  from './FloorPlanAction.jsx';
import { InquiryAction }    from './InquiryAction.jsx';

/**
 * Shared UI map for all catalog actions.
 * Maps domain action ID to its isolated React component.
 */
export const ACTION_UI_MAP = {
	[ACTION_IDS.FAVORITES]: (p, context) => (
		<FavoritesAction 
      key={`${ACTION_IDS.FAVORITES}-${p.id_cad ?? p.id_original}`} product={p} context={context} />
	),
	[ACTION_IDS.FLOOR_PLAN]: (p, context) => (
		<FloorPlanAction 
     key={`${ACTION_IDS.FLOOR_PLAN}-${p.id_cad ?? p.id_original}`} product={p} context={context} />
	),
	[ACTION_IDS.INQUIRY]: (p, context) => (
		<InquiryAction 
      key={`${ACTION_IDS.INQUIRY}-${p.id_cad ?? p.id_original}`} product={p} context={context} />
	),
};
